import { gql } from "@apollo/client";

const schema = {
  get: {
    name: "lab",
    serviceName: "graphql",
    query: gql`
      query lab($ids: [String], $for_admin: Int) {
        lab(ids: $ids, for_admin: $for_admin) {
          data {
            title
            alias
            is_active
            lat
            lng
            status {
              id
              title
            }
            manager {
              id
            }
          }
          total
        }
      }
    `,
  },
  update: {
    name: "updateLab",
    serviceName: "labadmin",
    query: gql`
      mutation updateLab(
        $ids: [String]!
        $title: String
        $alias: String
        $lat: String
        $lng: String
        $city: String
        $state: String
        $status_id: String
        $is_active: Int
        $manager_id: String # $local_info: String # $support_info: String # $management_info: String # $configs: String # $shipping_cost_config: String # $creator_id: String # $updator_id: String
      ) {
        updateLab(
          ids: $ids
          title: $title
          alias: $alias
          lat: $lat
          lng: $lng
          city: $city
          state: $state
          status_id: $status_id
          is_active: $is_active
          manager_id: $manager_id # local_info: $local_info # support_info: $support_info # management_info: $management_info # configs: $configs # shipping_cost_config: $shipping_cost_config # creator_id: $creator_id # updator_id: $updator_id
        ) {
          influenced_count
          messages
        }
      }
    `,
  },
};

export default schema;
